import React from "react";
import RedactionTool from "./RedactionTool";
import RedactionSummaryCard from "./common/RedactionSummaryCard";
import RedactionDetailsTable from "./common/RedactionDetailsTable";
import { useDashboard } from "../hooks/useDashboard";
import { Alert } from "react-bootstrap";

const Dashboard: React.FC = () => {
  const {
    redactionResult,
    lastJobSummary,
    handleRedactionComplete,
    downloadFile,
    downloadLink,
  } = useDashboard();

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-lg">
          <RedactionTool onRedactionComplete={handleRedactionComplete} />
        </div>
        <div className="bg-white p-6 rounded-lg">
          {lastJobSummary && (
            <>
              <RedactionSummaryCard summary={lastJobSummary} />
              <RedactionDetailsTable
                details={lastJobSummary.redaction_details}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
